import {createAsyncThunk} from '@reduxjs/toolkit';
import Api, {ApiMethods} from '../../../middleware/api';
import {notify} from '../../../modules/notifier/services/actions';
import {ViewDto} from '../../../dto/ViewDto';

type Args = {
    profileId: number;
    periodId: number;
    projectId: number;
};

export const getLastView = createAsyncThunk<ViewDto[], Args>(
    'lastView/getLastView',
    async ({profileId, periodId, projectId}, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `view/${profileId}?periodId=${periodId}&projectId=${projectId}`,
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return responseData;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const updateLastView = createAsyncThunk(
    'lastView/updateLastView',
    async (viewId: number, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `view/${viewId}`,
            method: ApiMethods.PUT
        });
        if (httpStatus === 201) {
            return viewId;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);
